var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Predloha"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M156.352 72.516c0 27.164-42.929 93.533-53.849 109.976-1.19 1.792-3.815 1.792-5.006 0-10.92-16.443-53.849-82.812-53.849-109.976 0-31.122 25.23-56.352 56.352-56.352s56.352 25.229 56.352 56.352z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 100,
    cy: 72.516,
    r: 28.152
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.8843dba063f8c397bcfb54730193e873.svg";
export { ForwardRef as ReactComponent };